import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useRecoilValue } from 'recoil'
import { axiosInstance } from '../api/http'
import { userIdAtom } from '../state/state'

export type TaskAnswerMediaPayload = {
  url: string
  type: string
  name?: string
  size?: number
}

export type SubmitTaskAnswerPayload = {
  contentId: number
  groupId: number
  text?: string
  medias?: TaskAnswerMediaPayload[]
}

export const useSubmitTaskAnswer = () => {
  const queryClient = useQueryClient()
  const userId = useRecoilValue(userIdAtom)

  return useMutation(
    ({ contentId, ...body }: SubmitTaskAnswerPayload) =>
      axiosInstance.mobile.contentControllerSubmitTaskAnswer(contentId, {
        contentId,
        ...body,
      }),
    {
      onSuccess: async (_data, { contentId }) => {
        await queryClient.invalidateQueries(['user', userId, 'new-content'])
        await queryClient.invalidateQueries(['user', userId, 'finished-content'])
        await queryClient.invalidateQueries(['user', userId, 'finished-content-filters'])
        await queryClient.invalidateQueries(['task-answer', contentId, userId])
      },
    },
  )
}

export const useTaskAnswerDetails = ({ contentId }: { contentId: number }) => {
  const userId = useRecoilValue(userIdAtom)

  return useQuery(
    ['task-answer', contentId, userId],
    () => axiosInstance.mobile.contentControllerGetTaskAnswer(contentId),
    {
      enabled: !!contentId && !!userId,
      select: ({ data }) => data.payload,
    },
  )
}
